export const MODEL_DISPLAY_SCALE = 0.000625;
export const BASE_SECTION_HEIGHT = 2000;
export const MODEL_SIDES_DISTANCE = 200;
export const MODEL_X_POSITION = -2;
export const CAMERA_FOV = 50;
